var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipmentTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H4.88283",
    stroke: "#2E77D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0869141 3.87748H3.44386V3.79028",
    stroke: "#2E77D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0869141 6.66772H2.00517",
    stroke: "#2E77D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58301 1H15.4331V11.5068",
    stroke: "#2E77D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5205 4.40039L19.139 5.6211C19.5314 5.75189 20.3161 6.22273 20.3161 7.05979V14.3404H18.9211",
    stroke: "#2E77D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5205 9.3269H18.6159",
    stroke: "#2E77D0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.741211 9.02173V14.2969H2.04911",
    stroke: "#2E77D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80371 14.3843H11.8146",
    stroke: "#2E77D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.0132,
    cy: 14.2534,
    r: 2.24659,
    stroke: "#2E77D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0874,
    cy: 14.2534,
    r: 2.24659,
    stroke: "#2E77D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.6L7.125 8L12 4",
    stroke: "#2E77D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentTruck);
export default __webpack_public_path__ + "static/media/shipmentTruck.d06ac3f7a91d70e8073eb406abb7acf8.svg";
export { ForwardRef as ReactComponent };